import React from 'react';
import { calcInventoryTotal } from '../utils';

const InventoryTable = (props) => {
  const { title, items = [] } = props;

  const sum = calcInventoryTotal(items);

  return (
    <div className="job-inventory-modal">
      <div className="job-inventory-modal-body">
        <div className="inventory-total">
          <div className="job-modal-category">
            <div className="job-modal-category-row job-modal-category-row__header">
              <p className="row-name">{title}</p>
            </div>
            <div className="job-modal-category-row job-modal-category-row__header">
              <p className="row-name">Name</p>
              <span className="w20">CF</span>
              <span className="w20">Qty</span>
              <span className="w20">Total</span>
            </div>
            {items.map((item) => {
              return (
                <div className="job-modal-category-row" key={item.id}>
                  <p className="row-name">{item.name}</p>
                  <span className="w20">
                    <span>{item.amount}</span>
                  </span>
                  <span className="w20">{item.qty}</span>
                  <span className="w20">{(item.amount * item.qty).toFixed(2)}</span>
                </div>
              );
            })}
            <div className="job-modal-category-row">
              <p className="row-name">Total</p>
              <span className="w20" style={{ fontWeight: 700 }}>
                {sum.cf} / {sum.pounds.toFixed(2)} lbs.
              </span>
              <span className="w20" style={{ fontWeight: 700 }}>
                {sum.quantity}
              </span>
              <span className="w20" style={{ fontWeight: 700 }}>
                {sum.total.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryTable;
